import React from "react";
import { Form, Input } from "antd";

const PriceFinalNDS = ({ form, disabled, parent }) => {
  const { getFieldDecorator } = form;

  return (
    <div className="offer-card__item">
      <span className="label">
        <span>
          НДС на цену {parent === "order" ? "заказа" : "предложения"}, руб:
        </span>
      </span>
      <Form.Item>
        {getFieldDecorator("priceFinalNDS")(
          <Input style={{ width: 224 }} disabled={disabled} />
        )}
      </Form.Item>
    </div>
  );
};

export default PriceFinalNDS;
